<template>
  <div class="footer">
    <!-- <div class="footer-top">
      <div class="item">
        <img src="../assets/f-tel.png" alt="" /> 0065+46372781
      </div>
      <div class="item">
        <img src="../assets/f-email.png" alt="" /> alex@azaleatechpte.com
      </div>
      <div class="item">
        <img src="../assets/f-address.png" alt="" /> 10 anson road #27-18 international plaza Singapore
      </div>
    </div> -->
    <div class="footer-box">
      <!-- <div class="logo-box">
        <img src="../assets/logo-1.png" class="logo-1" />
        <div class="br"></div>
        <div class="text">
          AZALEA will continue leveraging its industry advantages, strengthen
          cooperation with world-renowned companies, provide clients with higher
          quality services, and contribute to the development of the technology
          industry!
        </div>
      </div> -->

      <div class="menu-box">
        <div class="title">
          快速連結
        </div>
        <div class="list">
          <p @click="selectMenu(1)">藍圖</p>
          <p @click="selectMenu(2)">我們</p>
          <p @click="selectMenu(3)">招募</p>
          <p @click="selectMenu(5)">聯絡我們</p>
        </div>
      </div>
      <div class="menu-box">
        <div class="title">
          我們提供
        </div>
        <div class="list">
          <p>軟體開發</p>
          <p>技術支援</p>
          <p>商業投資</p>
          <p>價值評估</p>
        </div>
      </div>
      <div class="connect">
        <div class="title">
          聯絡我們
        </div>
        <!-- <p><img src="../assets/tel.png" alt="" /> 661655234</p> -->
        <p><img src="../assets/email.png" alt="" /> azion20130628@gmail.com</p>
        <p>
          <img src="../assets/address.png" alt="" /> ROOM D5 5/F KING YIP
          FACTORY BUILDING NO.59 KING YIP ST KWUN TONG KL
        </p>
      </div>
      <!-- <div class="send-box">
        <div class="title">
          Newsletter
        </div>
        <div class="br"></div>
        <p>GET IN TOUCH</p>
        <input class="email" type="text" placeholder="Your Email" />
        <div class="btn" @click="send()">send</div>
      </div> -->
    </div>

    <div class="copyright">
      Copyright © 2023.SAMORE HK LIMITED All Rights Reserved.
    </div>
  </div>
</template>
<style lang="less" scoped>
.footer {
  .footer-top {
    padding: 0 360px;
    height: 80px;
    line-height: 80px;
    background-color: #212121;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      img {
        width: 40px;
        height: 40px;
        vertical-align: middle;
        margin-right: 12px;
      }
    }
  }
  .footer-box {
    height: 240px;
    background: #333;
    padding: 120px 360px 106px 360px;
    display: flex;
    justify-content: space-between;
    .br {
      width: 60px;
      height: 2px;
      background-color: #504f4f;
      margin: 24px 0;
    }
    .logo-box {
      width: 400px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;

      .logo-1 {
        width: 220px;
        height: 40px;
      }
      .text {
      }
    }
    .connect {
      font-size: 14px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 16px;
      margin-top: 10px;
      .br {
        height: 1px;
      }
      .title {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 30px;
      }
      p {
        max-width: 300px;
        margin-bottom: 24px;
        img {
          width: 20px;
          vertical-align: middle;
          /* height: 20px; */
        }
      }
    }
    .menu-box {
      font-size: 14px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 16px;
      margin-top: 10px;
      .br {
        height: 1px;
      }
      .title {
        margin-bottom: 30px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
      .list {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 150px;
        p {
          cursor: pointer;
        }
      }
    }
    .send-box {
      margin-top: 10px;
      position: relative;
      .br {
        height: 1px;
      }
      p {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .title {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .email {
      background: #151414;
      border-radius: 8px;
      border: 1px solid #999;
      padding: 0 20px;
      width: 190px;
      color: #cccccc;
      height: 56px;
      margin-top: 38px;
      padding-right: 100px;
    }
    input[type="text"]:focus {
      outline: none;
    }
    .btn {
      width: 78px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: #f53a68;
      border-radius: 8px;
      color: #fff;
      position: absolute;
      right: 20px;
      top: 147px;
    }
    .customer {
      width: 120px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .copyright {
    height: 64px;
    text-align: center;
    background: #333333;
    font-size: 14px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
    line-height: 64px;
    border-top: 1px solid #404040;
  }
}
</style>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "offer" });
          break;
        case 4:
          this.$router.push({ path: "offers" });
          break;
        case 5:
          this.$router.push({ path: "contractUs" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
